var _defs, _path, _path2, _path3, _path4, _g, _path5, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBedExitActiveAlertLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 24 L 66.355469 24 L 66.355469 67.75 L 23 67.75 Z M 23 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.96875 40.855469 L 61.46875 40.855469 L 61.46875 63.355469 L 38.96875 63.355469 Z M 38.96875 40.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46.363281 40.855469 L 53 40.855469 L 53 58 L 46.363281 58 Z M 46.363281 40.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 40.855469 L 53.863281 40.855469 L 53.863281 57 L 47 57 Z M 47 40.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 58 L 53 58 L 53 63.355469 L 47 63.355469 Z M 47 58 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48 58 L 53 58 L 53 63.355469 L 48 63.355469 Z M 48 58 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6cb7c6",
    d: "M 36.449219 10.703125 C 27.796875 10.703125 19.839844 12.359375 13.410156 15.125 L 13.410156 29.152344 L 17.214844 27.699219 C 18.074219 23.371094 19.128906 21.238281 21.949219 20.609375 C 24.902344 19.949219 28.667969 19.578125 31.199219 20.390625 C 33.039062 20.980469 34.386719 23.328125 34.992188 25.367188 C 35.480469 25.371094 35.953125 25.394531 36.449219 25.394531 C 36.941406 25.394531 37.414062 25.371094 37.902344 25.367188 C 38.507812 23.328125 39.855469 20.980469 41.695312 20.390625 C 44.226562 19.578125 47.992188 19.949219 50.945312 20.609375 C 53.765625 21.238281 54.820312 23.371094 55.679688 27.699219 L 59.484375 29.152344 L 59.484375 15.125 C 53.054688 12.359375 45.097656 10.703125 36.449219 10.703125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cb7c6",
    d: "M 36.449219 29.496094 C 26.296875 29.496094 16.957031 31.445312 9.414062 34.6875 L 9.414062 56.867188 L 14.394531 56.867188 L 18.378906 51.320312 C 23.917969 52.117188 29.996094 52.585938 36.445312 52.585938 L 36.449219 52.585938 C 42.898438 52.585938 48.976562 52.117188 54.515625 51.320312 L 58.5 56.867188 L 63.480469 56.867188 L 63.480469 34.6875 C 55.9375 31.445312 46.597656 29.496094 36.449219 29.496094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cb7c6",
    d: "M 36.449219 7.554688 C 33.339844 7.554688 30.363281 7.820312 27.53125 8.261719 L 27.53125 18.460938 C 30.363281 18.710938 33.339844 18.863281 36.449219 18.863281 C 39.554688 18.863281 42.53125 18.710938 45.363281 18.460938 L 45.363281 8.261719 C 42.53125 7.820312 39.554688 7.554688 36.449219 7.554688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 65.046875 51.730469 C 65.046875 59.949219 58.359375 66.613281 50.109375 66.613281 C 41.859375 66.613281 35.171875 59.949219 35.171875 51.730469 C 35.171875 43.507812 41.859375 36.84375 50.109375 36.84375 C 58.359375 36.84375 65.046875 43.507812 65.046875 51.730469 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.069444, 0, 0, 1.065778, 9.413387, 7.553)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 52.020929 41.450911 C 52.020929 49.162413 45.767682 55.415181 38.053395 55.415181 C 30.339109 55.415181 24.085861 49.162413 24.085861 41.450911 C 24.085861 33.735743 30.339109 27.482975 38.053395 27.482975 C 45.767682 27.482975 52.020929 33.735743 52.020929 41.450911 Z M 52.020929 41.450911 ",
    stroke: "#6cb7c6",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cb7c6",
    d: "M 47.933594 47.59375 L 47.933594 43.046875 L 52.367188 43.046875 L 52.367188 47.492188 C 52.367188 49.6875 51.796875 53.539062 51.667969 54.289062 L 48.578125 54.289062 C 48.503906 53.5625 47.933594 49.765625 47.933594 47.59375 M 50.109375 55.710938 C 51.511719 55.710938 52.46875 56.691406 52.46875 58.058594 C 52.46875 59.429688 51.613281 60.410156 50.109375 60.410156 C 48.761719 60.410156 47.75 59.507812 47.75 58.058594 C 47.75 56.613281 48.761719 55.710938 50.109375 55.710938 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feffff",
    d: "M 50.21875 40.855469 C 44.007812 40.855469 38.96875 45.890625 38.96875 52.105469 C 38.96875 58.316406 44.007812 63.355469 50.21875 63.355469 C 56.433594 63.355469 61.46875 58.316406 61.46875 52.105469 C 61.46875 45.890625 56.433594 40.855469 50.21875 40.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc3333",
    d: "M 51.453125 57.148438 L 48.089844 57.148438 L 46.363281 41.710938 L 47.636719 40.867188 L 50.113281 53.472656 L 52.164062 56.355469 Z M 51.453125 57.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53535",
    d: "M 52.164062 56.355469 L 48.847656 56.355469 L 47.636719 40.867188 L 53.863281 40.867188 Z M 52.164062 56.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc3333",
    d: "M 48.589844 62.925781 C 47.957031 62.492188 47.558594 61.78125 47.558594 61.042969 C 47.523438 59.503906 49.167969 58.746094 50.523438 58.746094 C 51.882812 58.746094 52.386719 60.019531 52.394531 61.203125 C 52.398438 61.625 52.476562 61.792969 51.980469 62.394531 C 51.484375 62.992188 50.632812 63.339844 50.109375 63.339844 C 49.597656 63.339844 48.96875 63.183594 48.585938 62.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53535",
    d: "M 52.617188 60.882812 C 52.617188 61.167969 52.5625 61.4375 52.449219 61.703125 C 52.339844 61.964844 52.183594 62.195312 51.980469 62.394531 C 51.773438 62.59375 51.539062 62.75 51.273438 62.859375 C 51.007812 62.96875 50.730469 63.023438 50.441406 63.023438 C 50.152344 63.023438 49.875 62.96875 49.609375 62.859375 C 49.34375 62.75 49.105469 62.59375 48.902344 62.394531 C 48.699219 62.195312 48.542969 61.964844 48.429688 61.703125 C 48.320312 61.4375 48.265625 61.167969 48.265625 60.882812 C 48.265625 60.597656 48.320312 60.328125 48.429688 60.0625 C 48.542969 59.800781 48.699219 59.570312 48.902344 59.371094 C 49.105469 59.167969 49.34375 59.015625 49.609375 58.90625 C 49.875 58.796875 50.152344 58.742188 50.441406 58.742188 C 50.730469 58.742188 51.007812 58.796875 51.273438 58.90625 C 51.539062 59.015625 51.773438 59.167969 51.980469 59.371094 C 52.183594 59.570312 52.339844 59.800781 52.449219 60.0625 C 52.5625 60.328125 52.617188 60.597656 52.617188 60.882812 Z M 52.617188 60.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedExitActiveAlertLogo);
export default __webpack_public_path__ + "static/media/bed-exit-active-alert-logo.4a4e305300de8739377a0d1bbd476e2f.svg";
export { ForwardRef as ReactComponent };